'use client'

import { motion } from 'framer-motion'

const DistinctiveFactorsResultsBanner = () => {
  return (
    <motion.div
      className="bg-periwinkle-600 rounded-md p-5 my-7"
      initial={{ scale: 0.95, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.3, delay: 0.25 }}
    >
      <p className="pb-6">
        For the sector benchmark, data are collected using an AI-based approach to process large volumes of
        unstructured information found in corporate sustainability and annual reports.
      </p>
      <p>
        To ensure the sector&apos;s representation within the global economy, the present analysis is based on the reports
        of 82 companies for the year 2023, collectively accounting for at least 90% of global market capitalization.
      </p>
    </motion.div>
  )
}

export default DistinctiveFactorsResultsBanner
